import { Box } from "@mui/material";

const Showcase = () => {
    return (
        <Box className="showcase-container">
            <h4 className="showcase-title">What I'm currently playing</h4>
            <Box display="flex" justifyContent="space-around">
                <ShowcaseColumn
                    title="Home &mdash; SMB Touch & Roll"
                    image="/images/smbtar.jpg"
                    gameLink="https://en.wikipedia.org/wiki/Super_Monkey_Ball:_Touch_%26_Roll"
                    showcaseType='home'
                />
                <ShowcaseColumn
                    title="Arcade &mdash; Silent Scope EX"
                    image="/images/silentscopex.jpg"
                    gameLink="https://en.wikipedia.org/wiki/Silent_Scope"
                    showcaseType='arcade'
                />
            </Box>
        </Box>
    );
};

const ShowcaseColumn = ({title, image, gameLink, showcaseType}) => {
    return (
        <Box display="flex" flexDirection="column" className="showcase-column-box">
            <h5 className="showcase-subtitle">{title}</h5>
            <a href={gameLink}>
                <img
                    src={image}
                    alt={'video game banner'}
                    className={`showcase-image showcase-image-${showcaseType}`}
                />
            </a>
        </Box>
    )
}

export default Showcase;